/**
 * 「徒歩N分」の最小値を抽出する
 * access例: "都営新宿線｢小川町｣駅 徒歩2分 / 東京メトロ千代田線｢新御茶ノ水｣駅 徒歩2分"
 * 全角数字にも対応
 */
export function parseWalkMinutes(access: string | null | undefined): number | null {
  if (!access) return null;
  const normalized = access.replace(/[０-９]/g, (ch) =>
    String.fromCharCode(ch.charCodeAt(0) - 0xfee0)
  );
  const matches = normalized.match(/徒歩(\d+)分/g);
  if (!matches || matches.length === 0) return null;
  const minutes = matches.map((m) => {
    const n = m.match(/(\d+)/);
    return n ? parseInt(n[1], 10) : Infinity;
  });
  return Math.min(...minutes);
}

/**
 * 和暦テキストを西暦年に変換する
 * builtYear例: "昭和60年3月", "平成8年12月", "令和3年5月", "昭和46年11月・昭和55年2月"
 * 複数の場合は最初の年を返す
 */
export function convertWarekiToYear(builtYear: string | null | undefined): number | null {
  if (!builtYear) return null;
  const eraMap: Record<string, number> = {
    "明治": 1868,
    "大正": 1912,
    "昭和": 1926,
    "平成": 1989,
    "令和": 2019,
  };
  const match = builtYear.match(/(明治|大正|昭和|平成|令和)(\d+)年/);
  if (!match) return null;
  const base = eraMap[match[1]];
  if (base === undefined) return null;
  return base + parseInt(match[2], 10) - 1;
}

/**
 * 読点区切りの設備文字列を配列に分割する
 */
export function parseFacilities(facilities: string | null | undefined): string[] {
  if (!facilities) return [];
  return facilities
    .split(/[、,]/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}
